"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseOfferFS = void 0;
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const offerstore_api_models_1 = require("@integration/offerstore-api-models");
const base_models_1 = require("@integration/base-models");
const class_transformer_1 = require("class-transformer");
class BaseOfferFS extends base_models_1.Serializable {
}
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsUUID)(),
    (0, base_models_1.Docs)({
        example: '4db7554c-e5cc-4c31-82b0-8bc7d134c0f7',
        description: 'The unique offer id that is generated by coupling the proposition with a profile',
    }),
    tslib_1.__metadata("design:type", String)
], BaseOfferFS.prototype, "offerId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsIn)(Object.values(base_models_1.DurationInYears)),
    (0, base_models_1.Docs)({
        example: base_models_1.DurationInYears.FLEX,
        description: 'Proposition duration.',
    }),
    tslib_1.__metadata("design:type", String)
], BaseOfferFS.prototype, "duration", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.ValidateNested)({ each: true }),
    (0, class_transformer_1.Type)(() => offerstore_api_models_1.GetNextBestOfferResponseOfferIncentiveV2),
    tslib_1.__metadata("design:type", Array)
], BaseOfferFS.prototype, "incentives", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({ example: '513866', description: 'The campaign id, as stored in SAP and CDT' }),
    tslib_1.__metadata("design:type", String)
], BaseOfferFS.prototype, "cdtId", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Type)(() => Date),
    (0, base_models_1.Docs)({
        example: '2022-01-20T00:00:00.000Z',
        description: 'Date from which the proposition is valid.',
    }),
    tslib_1.__metadata("design:type", Date)
], BaseOfferFS.prototype, "validFrom", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Type)(() => Date),
    (0, base_models_1.Docs)({
        example: '2022-04-20T00:00:00.000Z',
        description: 'Date until when the proposition is valid.',
    }),
    tslib_1.__metadata("design:type", Date)
], BaseOfferFS.prototype, "validTo", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsDefined)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({
        example: 'Verleng DV Plus mono 1jr',
        description: 'The short description of the proposition. Currently set by the Campaign Management team.',
    }),
    tslib_1.__metadata("design:type", String)
], BaseOfferFS.prototype, "name", void 0);
tslib_1.__decorate([
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    (0, base_models_1.Docs)({
        example: 'vaste tarieven: DirectVoordeel Plus - tijdelijk aanbod',
        description: 'The description of the proposition. Currently set by the Campaign Management team.',
    }),
    tslib_1.__metadata("design:type", String)
], BaseOfferFS.prototype, "description", void 0);
exports.BaseOfferFS = BaseOfferFS;
